
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const Index = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already logged in, redirect to dashboard
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Hero section */}
      <header className="bg-white border-b">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Logo" className="h-8 w-8" />
            <span className="font-bold text-lg">CTCAD MFO Management System</span>
          </div>
          <div className="flex gap-4">
            <Link to="/login">
              <Button variant="ghost">Log in</Button>
            </Link>
          </div>
        </div>
      </header>
      
      <main className="flex-1">
        <section className="py-20 px-4">
          <div className="container mx-auto max-w-5xl">
            <div className="grid gap-8 md:grid-cols-2 items-center">
              <div className="space-y-6">
                <p className='text-gray-700 text-md'>Butuan City Tourism and Cultural Affairs Department</p>
                <h1 className="text-4xl md:text-5xl font-bold leading-tight">
                  Streamline your MFO management workflow
                </h1>
                <p className="text-lg text-gray-600">
                  Track tasks, manage departments, and improve collaboration with our comprehensive management system.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link to="/signup">
                    <Button size="lg" className="w-full sm:w-auto">
                      Get started
                    </Button>
                  </Link>
                  <Link to="/login">
                    <Button variant="outline" size="lg" className="w-full sm:w-auto">
                      Log in
                    </Button>
                  </Link>
                </div>
              </div>
              <div className="rounded-lg bg-gray-100 p-8 shadow-inner">
                <img 
                  src="/illustration.svg" 
                  alt="Dashboard preview" 
                  className="rounded-md shadow-md" 
                />
              </div>
            </div>
          </div>
        </section>
        
        <section className="py-16 bg-gray-50 px-4">
          <div className="container mx-auto max-w-5xl">
            <h2 className="text-3xl font-bold text-center mb-12">
              Key Features
            </h2>
            <div className="grid gap-8 md:grid-cols-3">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-semibold mb-3">Task Management</h3>
                <p className="text-gray-600">
                  Organize tasks with our intuitive Kanban board interface.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-semibold mb-3">Department Tracking</h3>
                <p className="text-gray-600">
                  Monitor performance and progress across different departments.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-semibold mb-3">Calendar View</h3>
                <p className="text-gray-600">
                  Plan and schedule MFO activities with our interactive calendar.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <footer className="bg-gray-100 py-8 px-4">
        <div className="container mx-auto">
          <div className="text-center text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} CTCAD MFO Management System. CSU BSIT Intern. Francis Tin-ao. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
